var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vue-root" }, [
    _c("div", { ref: "lightbox", staticClass: "lightbox d-none" }, [
      _c("iframe", {
        staticClass: "lightbox-frame",
        staticStyle: { border: "none" },
        attrs: {
          width: "100%",
          allowfullscreen: "true",
          mozallowfullscreen: "true",
          webkitallowfullscreen: "true",
          scrolling: "no",
          height: "100%",
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "lightbox-controls close position-absolute",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
          on: { click: _vm.closeLightbox },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "14.811",
                height: "14.811",
                viewBox: "0 0 14.811 14.811",
              },
            },
            [
              _c("path", {
                attrs: {
                  id: "close.2",
                  d: "M14.811.873,13.938,0,7.405,6.533.873,0,0,.873,6.533,7.405,0,13.938l.873.873L7.405,8.278l6.533,6.533.873-.873L8.278,7.405Z",
                },
              }),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "position-relative" }, [
      _c(
        "div",
        {
          staticClass:
            "position-absolute w-100 d-flex justify-content-center top-0 left-0 upperOverlay",
        },
        [
          _c("div", { staticClass: "container px-4 px-xl-3" }, [
            _c(
              "a",
              {
                staticClass: "backBtn d-inline-flex align-items-center",
                attrs: { href: "#", onclick: "history.back()" },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "mr-2",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "4",
                      height: "5.419",
                      viewBox: "0 0 4 5.419",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        id: "play-button",
                        d: "M.056,2.6,3.8.023A.129.129,0,0,1,4,.129V5.29a.129.129,0,0,1-.2.106L.056,2.816a.129.129,0,0,1,0-.212Z",
                        opacity: "0.6",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.t("pagination.previous")))]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "iconContainer d-flex flex-column position-absolute right-0 top-0",
            },
            _vm._l(_vm.iconsRight, function (icon) {
              return _c("img", { attrs: { src: icon.path, loading: "lazy" } })
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "w-100 d-flex justify-content-center bg-light-grey" },
        [
          _c("div", { staticClass: "container px-4 px-xl-3" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-md-5 productdetail__details pr-3 pr-xl-5 pb-3",
                },
                [
                  _c("h2", [_vm._v(_vm._s(_vm.product.subtitle))]),
                  _vm._v(" "),
                  _c("h1", { staticClass: "pt-1" }, [
                    _vm._v(_vm._s(_vm.product.title)),
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "pt-3 pt-md-5" }, [
                    _vm._v(
                      _vm._s(_vm.t("product.from")) +
                        " " +
                        _vm._s(_vm.product.priceFormatted)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("h4", [_vm._v(_vm._s(_vm.t("product.infoprice")))]),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "pt-2 pt-md-5",
                    domProps: {
                      innerHTML: _vm._s(_vm.product.shortDescription),
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex btnRow px-4 py-3 px-sm-0 py-sm-0 bg-light-grey w-100 w-sm-auto",
                    },
                    [
                      _vm.compareEnabled
                        ? _c(
                            "button",
                            {
                              staticClass: "d-none d-sm-block btn btn-second",
                              attrs: { href: "#" },
                              on: { click: _vm.addProductToCompare },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.t("product.compare"))),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.compareEnabled
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "mobileVersion d-flex d-sm-none btn btn-second justify-content-center align-items-center",
                              attrs: { href: "#" },
                              on: { click: _vm.addProductToCompare },
                            },
                            [
                              _c("span", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.t("product.compare"))),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.configuratorUrl
                        ? _c(
                            "button",
                            {
                              staticClass: "d-none d-sm-block btn btn-second",
                              attrs: { href: "#" },
                              on: { click: _vm.openConfiguratorUrl },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.t("product.configurator_label"))
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.configuratorUrl
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "mobileVersion d-flex d-sm-none btn btn-second justify-content-center align-items-center",
                              attrs: { href: "#" },
                              on: { click: _vm.openConfiguratorUrl },
                            },
                            [
                              _c("span", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.t("product.configurator_label"))
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12 col-md-7 productdetail__pointer",
                  on: { click: _vm.closePointerPopup },
                },
                [
                  _c(
                    "div",
                    { staticClass: "position-relative" },
                    [
                      _c("img", {
                        staticClass: "w-100",
                        attrs: { src: _vm.image, loading: "lazy" },
                      }),
                      _vm._v(" "),
                      _vm.product.url3d
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-none d-md-flex position-absolute threeDPin button-3d lightbox-open",
                                on: {
                                  click: function ($event) {
                                    return _vm.openLightbox(_vm.product.url3d)
                                  },
                                },
                              },
                              [
                                _c("inline-svg", {
                                  attrs: { src: "/img/threeDPin.svg" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex d-md-none position-absolute threeDPin",
                                on: {
                                  click: function ($event) {
                                    return _vm.openLightbox(_vm.product.url3d)
                                  },
                                },
                              },
                              [
                                _c("inline-svg", {
                                  attrs: { src: "/img/threeDPinSmall.svg" },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.pointers, function (pointer) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "position-absolute productDetailPin",
                              style: {
                                top: pointer.y + "%",
                                left: pointer.x + "%",
                              },
                              on: { click: _vm.openPointerPopup },
                            },
                            [
                              _c("inline-svg", {
                                attrs: { src: "/img/productDetailPin.svg" },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "position-absolute productDetailPin__content",
                                },
                                [
                                  _vm.getPointerImageByIndex(pointer.bild_nr)
                                    ? [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getPointerImageByIndex(
                                              pointer.bild_nr
                                            ),
                                            loading: "lazy",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("h4", [_vm._v(_vm._s(pointer.label))]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "text-white p-3" }, [
                                    _vm._v(_vm._s(pointer.text)),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "w-100 d-flex justify-content-center" }, [
      _c("div", { staticClass: "container px-4 px-xl-3" }, [
        _c(
          "div",
          { staticClass: "tabSwitcher d-flex flex-wrap" },
          _vm._l(_vm.tabs, function (buttonTab, key) {
            return _c(
              "button",
              {
                staticClass: "pb-2 mb-4",
                class: { active: _vm.activeTab === key },
                on: {
                  click: function ($event) {
                    _vm.activeTab = key
                  },
                },
              },
              [_vm._v(_vm._s(buttonTab.btnName))]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tabContainer position-relative" },
          [
            _vm.tabs.description && _vm.activeTab == "description"
              ? [
                  _c("div", { staticClass: "tabContainer__inner row" }, [
                    _vm.tabs.description.headline
                      ? _c("h2", {
                          staticClass: "col-12",
                          domProps: {
                            textContent: _vm._s(_vm.tabs.description.headline),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-lg-7" }, [
                      _vm.tabs.description.maintext
                        ? _c("div", {
                            staticClass: "mainText",
                            domProps: {
                              innerHTML: _vm._s(_vm.tabs.description.maintext),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.tabs.description.urls
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "pt-2 mt-2 mt-lg-4 mb-4 pt-xl-0 d-flex flex-column flex-md-row additionalLinks",
                            },
                            _vm._l(_vm.tabs.description.urls, function (url) {
                              return url.href
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-second mr-0 mr-md-2 mb-2 mb-md-0 w-100 w-sm-auto",
                                      attrs: {
                                        href: url.href,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(url.label) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e()
                            }),
                            0
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 col-lg-5 additionalInfo" },
                      [
                        _vm.tabs.description.materialAndTechnik
                          ? _c("h3", { staticClass: "pb-2" }, [
                              _vm._v(_vm._s(_vm.t("product.material_technic"))),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "pb-5",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.tabs.description.materialAndTechnik
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _vm.tabs.description.manual
                          ? _c("h3", { staticClass: "pb-2" }, [
                              _vm._v(_vm._s(_vm.t("product.operation"))),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "pb-5 pb-lg-2",
                          domProps: {
                            innerHTML: _vm._s(_vm.tabs.description.manual),
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 spacer" }),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "iconDetails" },
                      _vm._l(
                        _vm.tabs.description.iconInfos,
                        function (iconTab, index) {
                          return _c(
                            "div",
                            { staticClass: "iconDetails__item pr-3" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-wrap pb-4" },
                                _vm._l(iconTab.icons, function (icon) {
                                  return _c("div", {
                                    staticClass: "iconDetails__item__icon",
                                    style: {
                                      "background-image":
                                        "url(/assets/productdetail/images/" +
                                        icon +
                                        ")",
                                    },
                                  })
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c("h3", { staticClass: "pb-2" }, [
                                _vm._v(_vm._s(iconTab.title)),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "pb-1" }, [
                                _vm._v(_vm._s(iconTab.description)),
                              ]),
                              _vm._v(" "),
                              iconTab.popup.extra_description
                                ? [
                                    _c("p", { staticClass: "pb-1" }, [
                                      _vm._v(
                                        _vm._s(iconTab.popup.extra_description)
                                      ),
                                    ]),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              iconTab.popup
                                ? [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "pb-2",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openPopup(
                                              index,
                                              iconTab.popup.url
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(iconTab.popup.label)),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "iconDetails__item__popup bg-white position-fixed h-100 w-100 d-flex flex-column justify-content-between",
                                        class: {
                                          active: _vm.activeIconTab == index,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "iconDetails__item__popup__upper d-flex",
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                staticClass: "mr-5",
                                                attrs: {
                                                  id: "Information",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  width: "13.829",
                                                  height: "13.829",
                                                  viewBox: "0 0 13.829 13.829",
                                                },
                                              },
                                              [
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      id: "Border",
                                                      fill: "#f8f8f8",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d: "M 6.914713859558105 13.57942390441895 C 3.239783763885498 13.57942390441895 0.2500038743019104 10.58964347839355 0.2500038743019104 6.914713859558105 C 0.2500038743019104 3.239783763885498 3.239783763885498 0.2500038743019104 6.914713859558105 0.2500038743019104 C 10.58964347839355 0.2500038743019104 13.57942390441895 3.239783763885498 13.57942390441895 6.914713859558105 C 13.57942390441895 10.58964347839355 10.58964347839355 13.57942390441895 6.914713859558105 13.57942390441895 Z",
                                                        stroke: "none",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d: "M 6.914713859558105 0.5000038146972656 C 3.377634048461914 0.5000038146972656 0.5000038146972656 3.377634048461914 0.5000038146972656 6.914713859558105 C 0.5000038146972656 10.4517936706543 3.377634048461914 13.32942390441895 6.914713859558105 13.32942390441895 C 10.4517936706543 13.32942390441895 13.32942390441895 10.4517936706543 13.32942390441895 6.914713859558105 C 13.32942390441895 3.377634048461914 10.4517936706543 0.5000038146972656 6.914713859558105 0.5000038146972656 M 6.914713859558105 3.814697265625e-06 C 10.73360443115234 3.814697265625e-06 13.82942390441895 3.095824241638184 13.82942390441895 6.914713859558105 C 13.82942390441895 10.73360443115234 10.73360443115234 13.82942390441895 6.914713859558105 13.82942390441895 C 3.095824241638184 13.82942390441895 3.814697265625e-06 10.73360443115234 3.814697265625e-06 6.914713859558105 C 3.814697265625e-06 3.095824241638184 3.095824241638184 3.814697265625e-06 6.914713859558105 3.814697265625e-06 Z",
                                                        stroke: "none",
                                                        fill: "#e60014",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    id: "Icon",
                                                    d: "M33.916,5.78l-.091.37q-.407.161-.65.245a1.715,1.715,0,0,1-.564.084,1.125,1.125,0,0,1-.767-.241.779.779,0,0,1-.274-.611,2.161,2.161,0,0,1,.02-.294q.021-.15.066-.339L32,3.793q.045-.173.076-.327a1.422,1.422,0,0,0,.031-.282.435.435,0,0,0-.095-.321.537.537,0,0,0-.363-.091.951.951,0,0,0-.27.041c-.092.027-.171.054-.238.078l.091-.37q.334-.136.638-.232a1.909,1.909,0,0,1,.577-.1,1.1,1.1,0,0,1,.755.237.786.786,0,0,1,.265.615c0,.052-.006.144-.018.276a1.843,1.843,0,0,1-.068.362l-.338,1.2a3.18,3.18,0,0,0-.074.33,1.7,1.7,0,0,0-.033.28.4.4,0,0,0,.106.325.6.6,0,0,0,.37.086,1.068,1.068,0,0,0,.28-.043A1.563,1.563,0,0,0,33.916,5.78ZM34,.757a.7.7,0,0,1-.236.533.8.8,0,0,1-.569.22.814.814,0,0,1-.572-.22.7.7,0,0,1-.239-.533.706.706,0,0,1,.239-.535.845.845,0,0,1,1.142,0A.707.707,0,0,1,34,.757Z",
                                                    transform:
                                                      "translate(-25.897 3.436)",
                                                    fill: "#e60014",
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("h3", [
                                              _vm._v(
                                                _vm._s(_vm.t("product.info"))
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._m(1, true),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "w-100 iconDetails__item__popup__closer",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "d-flex w-100 py-4 justify-content-center align-items-center",
                                                on: { click: _vm.closePopup },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.t("product.close")
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ]
              : _vm.tabs.technicalDetails && _vm.activeTab == "technicalDetails"
              ? [
                  _c("div", { staticClass: "tabContainer__inner" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.technicalImage,
                        width: "100%",
                        loading: "lazy",
                      },
                    }),
                  ]),
                ]
              : _vm.tabs.colors && _vm.activeTab == "colors"
              ? [
                  _c(
                    "div",
                    { staticClass: "tabContainer__inner colors row" },
                    [
                      _vm._l(_vm.colors, function (color) {
                        return [
                          _c(
                            "div",
                            { staticClass: "col-6 col-md-4 col-lg-3" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "color",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeImage(color.path)
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.mediaPath + color.path,
                                      loading: "lazy",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("h2", { staticClass: "pt-2" }, [
                                    _vm._v(_vm._s(color.subtitle)),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "pt-2" }, [
                                    _vm._v(_vm._s(color.title)),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 d-flex d-xl-none" }, [
      _c("div", { staticClass: "borderBottom" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "iconDetails__item__popup__middle" }, [
      _c("h2", [_vm._v("Befestigungslösungen")]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "Zu einem Sonnenschirm gehört auch die richtige Befestigungslösung. Auf der sicheren Seite sind Besitzer:innen von Glatz-Schirmen , wenn sie das Original-Zubehör für eine optimale Befestigung und Standsicherheit verwenden."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Nur so sind die Stabilität gemäss unsere Leistungsversprechen (wie zum Beispiel die Windfestigkeit und die Glatz-Gewährleistung garantiert. Je nach Situation und Einsatzort bietet Glatz verschiedene Befestigungslösungen. Beachten Sie bitte die von Glatz empfohlenen Befestigungsmöglichkeiten inklusive dem Mindestgewicht für das jeweilige Schirmmodell (Übersicht Schirme Befestigungs-möglichkeiten direkt auf der Seite:)"
        ),
      ]),
      _vm._v(" "),
      _c("h4", [_vm._v("Wann wird welche Befestigung empfohlen?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Hat der Sonnenschirm einen festen Platz auf der Terrasse, der sich nicht ändert? Dann empfehlen wir Ihnen eine fest einbetonierte Bodenhülse, damit kein Sockel stört und zur Stolperfalle wird. Insbesondere für Gastronomiebetriebe ist diese Art der Befestigung sehr sinnvoll. "
        ),
        _c("br"),
        _c("br"),
        _vm._v(
          "Sie möchten Ihre Beschattung dem täglichen Sonnenverlauf anpassen? Dann ist ein Sockel mit Rollen für Sie die optimale Lösung. "
        ),
        _c("br"),
        _c("br"),
        _vm._v(
          "Steht Ihr Sonnenschirm die meiste Zeit am gleichen Ort und behindert keine Laufwege? Dann empfehlen wir Ihnen, als Sonnenschirmständer einen Sockel zu verwenden. Sockel gibt es in verschiedenen Abmessungen, Gewichten und Materialien.\n                                        "
        ),
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "#" } }, [
        _c("p", [_vm._v("Hier erfahren Sie mehr")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }